/* eslint-disable react/style-prop-object */
import React from 'react';
import clsx from 'clsx';
import { Button, Content, Flex, Grid, Heading, IllustratedMessage, Text, View, } from '@adobe/react-spectrum';
import Upload from '@spectrum-icons/illustrations/Upload';
import { Prompt } from 'app/stores/editor/prompt';
import { useAppDispatch } from 'app/stores/store';
import { getDefaultFileSelectHandler } from 'app/views/components/empty/FilePicker';
import { FilePickerBase } from 'app/views/components/empty/FilePickerBase';
import { useDropzone } from 'app/views/hooks/useDropzone';
import { useFilePaste } from 'app/views/hooks/useFilePaste';
import { analytics } from 'app/utils/analytics';
import { call } from 'app/utils/function';
import { getSupportedMimeTypes } from 'app/utils/upload';
import { DividerLabel } from '../core/DividerLabel';
import { Capture } from './Capture';
import { Download } from './Download';
import { Samples } from './Samples';
const DropzoneWrapperStyle = {
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
};
export const EmptyView = (props) => {
    const { showBorder = true, showSamples = true, onSelect } = props;
    const fileMaxSize = configGet('fileUploadMaxSize', 1e6);
    const dispatch = useAppDispatch();
    const supportedMimeTypes = getSupportedMimeTypes();
    const pasteErrorHandler = React.useCallback((error) => {
        dispatch(Prompt.show({
            title: 'Clipboard error',
            content: `Reading clipboard content has failed with error\n${error.toString()}`,
            variant: 'error',
        }));
    }, [dispatch]);
    const { getRootProps, isDragActive, acceptedFiles } = useDropzone({
        noDragEventsBubbling: true,
    });
    const [pastedFile] = useFilePaste({
        accept: supportedMimeTypes,
        maxSize: fileMaxSize,
        onError: pasteErrorHandler,
    });
    const onSelectFiles = React.useCallback((files, source) => {
        getDefaultFileSelectHandler(dispatch)(files, source);
        call(onSelect);
    }, [onSelect, dispatch]);
    React.useEffect(() => {
        if (acceptedFiles.length) {
            analytics({
                action: 'FileDrop',
                label: 'importer',
            });
            onSelectFiles(acceptedFiles, 'file');
        }
    }, [acceptedFiles, onSelectFiles]);
    React.useEffect(() => {
        if (pastedFile) {
            analytics({
                action: 'FilePaste',
                label: 'importer',
            });
            onSelectFiles([pastedFile], 'clipboard');
        }
    }, [pastedFile, onSelectFiles]);
    return (React.createElement("div", Object.assign({ style: DropzoneWrapperStyle }, getRootProps({
        className: clsx('content-select', 'image-picker-view'),
    })),
        React.createElement(View, { padding: "size-150", borderRadius: "medium", backgroundColor: "gray-100" },
            React.createElement(View, { padding: "size-300", borderColor: isDragActive ? 'blue-600' : 'gray-200', borderWidth: showBorder ? 'thin' : 'none', borderRadius: "medium", UNSAFE_style: { borderStyle: 'dashed;!important' } },
                React.createElement(IllustratedMessage, null,
                    React.createElement(Upload, { "aria-label": "Upload image cta image" }),
                    React.createElement(Heading, { level: 6 }, "Drag and Drop or Paste your image(s)"),
                    React.createElement(Content, null,
                        React.createElement(View, { marginY: "size-150" },
                            React.createElement(Flex, { direction: "column" },
                                React.createElement(Text, { marginTop: "size-150" }, "Or select a file(s) from your computer"),
                                React.createElement(FilePickerBase, { className: "btn-large", onSelect: onSelectFiles }, open => (React.createElement(Button, { margin: "size-100", variant: "cta", onPress: open }, "Select file"))))),
                        React.createElement(DividerLabel, null, "you can also use one of these options"),
                        React.createElement(Grid, { marginY: "size-150", areas: ['left  right'], columns: ['1fr', '1fr'], rows: ['1fr'], gap: "size-200" },
                            React.createElement(Download, { onSelect: onSelect }),
                            React.createElement(Capture, { onSelect: onSelect })),
                        showSamples && React.createElement(Samples, { onSelect: onSelect })))))));
};
